/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "revqz",
  title: "Hi all, I'm revqz",
  subTitle: emoji(
    "A passionate 18-year-old developer specializing in BDS, Hytale, and Bukkit development."
  ),
  resumeLink: "/cv.pdf", // Served from public/. Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/revqz1",
  linkedin: "https://www.linkedin.com/in/omri-daniel-ba30553b3/",
  gmail: "contact@revqz.me",
  portfolio: "https://revqz.me/portfolio",
  blog: "https://revqz.me/blog",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "BDS, Hytale, and Bukkit Developer",
  skills: [
    emoji("⚡ Bukkit and Hytale server-side development in Java"),
    emoji("⚡ BDS (Bedrock Scripting) and JavaScript gameplay systems"),
    emoji(
      "⚡ Data and infrastructure with SQL, MongoDB, Firebase, Kubernetes, and Docker"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Java",
      fontAwesomeClassname: "devicon-java-plain colored"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "devicon-javascript-plain colored"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "devicon-mongodb-plain colored"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "devicon-firebase-plain colored"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "devicon-kubernetes-plain colored"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "devicon-docker-plain colored"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Bukkit Development", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Hytale",
      progressPercentage: "70%"
    },
    {
      Stack: "BDS (Bedrock Scripting) — JavaScript",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Backend & Minigames Developer",
      company: "PvPTiers",
      companylogo: require("./assets/images/pvptiersLogo.png"),
      date: "Present",
      desc: "Official Partners & Owners of MCPVP.com. Building backend services and custom minigames for the network.",
      descBullets: []
    },
    {
      role: "Infrastructure & Lead Developer",
      company: "SumoSMP",
      companylogo: require("./assets/images/sumosmpLogo.png"),
      date: "Present",
      desc: "Owned by SumoGG, a YouTuber with 100k+ subscribers. Leading development and running the server infrastructure.",
      descBullets: []
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Claude Skill Developer",
      subtitle:
        "Engineered intelligent capabilities and custom integrations leveraging Anthropic's Claude AI models.",
      image:
        "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Cpath d='M128 48 C 128 112, 80 80, 48 128 C 80 176, 128 144, 128 208 C 128 144, 176 176, 208 128 C 176 80, 128 112, 128 48 Z' fill='%23D97757'/%3E%3Ccircle cx='128' cy='128' r='16' fill='%23F0ECE1'/%3E%3C/svg%3E",
      imageAlt: "Claude Skill Developer",
      footerLink: []
    },
    {
      title: "Math Regional Finalist & Programming President",
      subtitle:
        "Led my former school's Programming Club as President and successfully competed as a Regional Finalist in competitive mathematics.",
      image:
        "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Cpath d='M176 64 L80 64 L128 128 L80 192 L176 192' fill='none' stroke='%2322C55E' stroke-width='24' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M48 48 L208 48' fill='none' stroke='%23166534' stroke-width='8' stroke-linecap='round'/%3E%3C/svg%3E",
      imageAlt: "Math and Programming",
      footerLink: []
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
// The resume itself is a static PDF at public/cv.pdf, linked from the
// "Download my resume" button in the Greeting section (greeting.resumeLink).
// This block only controls the "Resume" link in the header nav, which
// anchors to that button.
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true // Set false to hide the Resume link in the nav
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "contact@revqz.me"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

// Reviews Section
const reviewsSection = {
  title: "What My Customers Say",
  subtitle:
    "Join thousands of satisfied customers who trust us with their hosting needs",
  display: false, // Set false to hide this section
  reviews: [
    {
      name: "lennontech",
      username: "@lennontech",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "thank you revqz.made me an amazing, works perfectly, good communication and experience. very pleased with the end result. thank you, money well spent"
    },
    {
      name: "glowcraft",
      username: "@glowcraft",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "Hired to help make a big Ad plugin. Did everything I asked was above what was expecting. Will Def be using services again."
    },
    {
      name: ".trioxide",
      username: "@.trioxide - Wicklow.gg",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "Amazing job, very clean web development, good price"
    },
    {
      name: "Frostbite",
      username: "@frostbite",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "revqz is an absolute lifesaver. Handled our entire backend server migration to a new dedicated host with zero downtime. 10/10 would hire again."
    },
    {
      name: "ZephyrHQ",
      username: "@zephyrhq",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "Exceptional work on our custom Java minigames. The code was clean, well-documented, and delivered exactly according to our timeline."
    },
    {
      name: "Aura Network",
      username: "@auranetwork",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "Set up our complete DevOps pipeline and secured our databases. Very knowledgeable in SecOps, highly recommended for any scaling server network."
    },
    {
      name: "Pixelate",
      username: "@pixelate",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "Incredible full-stack developer. Built our entire server web portal from scratch using Node.js and Tailwind. Super responsive to feedback!"
    },
    {
      name: "ApexMC",
      username: "@apexmc",
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      rating: 5,
      text: "Fixed bugs in our core plugins that previous developers couldn't solve for weeks. revqz knows their stuff inside out."
    }
  ]
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  reviewsSection
};
